import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import {
  mainHeadingTypographyStyles,
  rubikTypographyStyles,
} from '../../../shared/ui';

type RegistrationCompleteHeadingProps = {
  state: 'congrats' | 'card';
};

const Heading = styled.div.attrs({
  'data-ui': 'registration-complete-heading',
})`
  width: ${({ theme }) => theme.scale.px(341)};
  display: grid;
  gap: ${({ theme }) => theme.scale.px(8)};
`;

const Title = styled.h1`
  ${mainHeadingTypographyStyles};
  line-height: ${({ theme }) => theme.scale.px(28)};
  white-space: pre-line;
`;

const Subtitle = styled.p`
  ${rubikTypographyStyles};
  margin: 0;
  font-size: ${({ theme }) => theme.scale.px(15)};
  font-weight: 400;
  line-height: ${({ theme }) => theme.scale.px(18)};
  white-space: pre-line;
`;

export function RegistrationCompleteHeading({
  state,
}: RegistrationCompleteHeadingProps) {
  const { t } = useTranslation();

  return (
    <Heading>
      <Title>
        {t(
          state === 'congrats'
            ? 'registrationComplete.congrats.title'
            : 'registrationComplete.card.title',
        )}
      </Title>
      <Subtitle>
        {t(
          state === 'congrats'
            ? 'registrationComplete.congrats.subtitle'
            : 'registrationComplete.card.subtitle',
        )}
      </Subtitle>
    </Heading>
  );
}
